// Implements: F-RPT-006, F-RPT-007
/**
 * Mockup v3 P9: the day windows the report screens offer, counted on the calendar of the day they
 * are handed (an injectable `Date`, never a hidden clock: checklist 16): the month so far (from its
 * first day to that day) and the last N days (that day included). Days are `YYYY-MM-DD`, written
 * from a UTC date so no browser zone moves them. Pure.
 */

import type { ReportWindow } from "../../types/reports";

/** `YYYY-MM-DD` of a calendar day (year, 1-based month, day), whatever the browser's zone. */
export function isoDay(year: number, month: number, day: number): string {
  const instant = new Date(Date.UTC(year, month - 1, day));
  return instant.toISOString().slice(0, 10);
}

/** The month of `today` so far: its first day to `today`. */
export function monthToDate(today: Date): ReportWindow {
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  return { from: isoDay(year, month, 1), to: isoDay(year, month, today.getDate()) };
}

/** The `count` days ending on `today`, both ends included. */
export function lastDays(today: Date, count: number): ReportWindow {
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  return { from: isoDay(year, month, today.getDate() - (count - 1)), to: isoDay(year, month, today.getDate()) };
}
